
import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"
import toast, { Renderable, Toast, Toaster, ValueFunction } from 'react-hot-toast';

const ReactSwal = withReactContent(Swal)

export const AlertService = {

    warning: async (title: string | JSX.Element, content: string | JSX.Element, preConfirm: () => any, confirmButtonText = 'Continuar' ) => {
        const { isConfirmed } = await ReactSwal.fire({
            title: title,
            html: content,
            icon: 'warning',
            iconColor: '#f5ca99',
            confirmButtonText: confirmButtonText,
            cancelButtonText: 'Cancelar',
            customClass: {
                cancelButton: 'btn btn-light order-1  me-3',
                confirmButton: 'btn btn-primary order-2',
            },
            buttonsStyling: false,
            showConfirmButton: true,
            focusDeny: true,
            focusCancel: true,
            showCancelButton: true,
            showLoaderOnConfirm: true,
            preConfirm: preConfirm
        })

        return isConfirmed
    },
    success: async (title: string | JSX.Element, content: string | JSX.Element, confirmButtonText= 'OK') => {
        const { isConfirmed } = await ReactSwal.fire({
            title: title,
            html: content,
            icon: 'success',
            // iconColor: '#f5ca99',
            confirmButtonText: confirmButtonText,
            customClass: {
                cancelButton: 'btn btn-light order-1  me-3',
                confirmButton: 'btn btn-primary order-2',
            },
            buttonsStyling: false,
        })

        return isConfirmed
    },
    error: async (title: string | JSX.Element, content: string | JSX.Element, confirmButtonText= 'OK') => {
        const { isConfirmed } = await ReactSwal.fire({
            title: title,
            html: content,
            icon: 'error',
            // iconColor: '#f5ca99',
            confirmButtonText: confirmButtonText,
            customClass: {
                cancelButton: 'btn btn-light order-1  me-3',
                confirmButton: 'btn btn-primary order-2',
            },
            buttonsStyling: false,            
        })

        return isConfirmed
    },

    toastLoading: (promise: Promise<unknown> | (() => Promise<unknown>), loadingMessage: any, successMessage: any, errorMessage: any ) => {
        toast.promise(promise, {
            loading: loadingMessage,
            success: successMessage,
            error: errorMessage,
            
        }, {
            duration: 4000,
            style: {
                // borderRadius: '10px',
                background: '#333',
                color: '#fff',
            }
        });

    },
    toastSuccess: (message: Renderable | ValueFunction<Renderable, Toast>, duration = 4000) => {
        toast.success(message, {
            duration,
            style: {
                // borderRadius: '10px',
                background: '#333',
                color: '#fff',
            }
        });
    },
    toastError: (message: Renderable | ValueFunction<Renderable, Toast>, duration = 4000) => {
        toast.error(message, {
            duration,
            style: {
                // borderRadius: '10px',
                background: '#333',
                color: '#fff',
            }
        });
    }
}